import { useUserRoles } from '../auth/useUserRoles';
import { useIsRideOrderingPortalEnabledForOrganization } from './useIsRideOrderingPortalEnabledForOrganization';

export function useShouldShowRideOrderingPortalFeatures() {
  const { isRideOrderingPortalUser } = useUserRoles();
  const isRideOrderingPortalEnabledForOrganization =
    useIsRideOrderingPortalEnabledForOrganization();
  return isRideOrderingPortalUser && isRideOrderingPortalEnabledForOrganization;
}
